import './MenuFooter.scss';

export const MenuFooter = () => {

    return (null);
};

export default MenuFooter;
